import {NgModule} from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {EngineEtlService} from './api/engineEtl.service';
import {EnginePublicLandingPageService} from './api/enginePublicLandingPage.service';
import {EngineRgpdService} from './api/engineRgpd.service';
import {EngineScriptService} from './api/engineScript.service';
import {EngineTransactionalEmailService} from './api/engineTransactionalEmail.service';
import {EngineWebHookService} from './api/engineWebHook.service';
import {EngineQueryService} from './api/engineQuery.service';

import {ConfiguratorDataViewService} from './api/configuratorDataView.service';
import {ConfiguratorDatastoreService} from './api/configuratorDatastore.service';
import {ConfiguratorEtlService} from './api/configuratorEtl.service';
import {ConfiguratorFileConnectionService} from './api/configuratorFileConnection.service';
import {ConfiguratorLandingPageService} from './api/configuratorLandingPage.service';
import {ConfiguratorPageHtml5Service} from './api/configuratorPageHtml5.service';
import {ConfiguratorPublicLandingPageService} from './api/configuratorPublicLandingPage.service';
import {ConfiguratorScriptService} from './api/configuratorScript.service';
import {ConfiguratorSendInBlueService} from './api/configuratorSendInBlue.service';
import {ConfiguratorTableService} from './api/configuratorTable.service';
import {ConfiguratorTemplateHtmlService} from './api/configuratorTemplateHtml.service';
import {ConfiguratorTenantService} from './api/configuratorTenant.service';
import {ConfiguratorTransactionalEmailService} from './api/configuratorTransactionalEmail.service';
import {ConfiguratorWorkflowService} from './api/configuratorWorkflow.service';
import {DmpApiHttpInterceptor} from './dmp-api-http.interceptor';
// import {GraphQlService} from './graphql/graph-ql.service';
import {ConfiguratorNewsletterService} from './api/configuratorNewsletter.service';
import {ConfiguratorConfigurationService} from './api/configuratorConfiguration.service';
import {EnginePublicPersonalService} from './api/enginePublicPersonal.service';
import {ConfiguratorTokenService} from './api/configuratorToken.service';
import {ConfiguratorPublicNewsletterService} from './api/configuratorPublicNewsletter.service';
import {ConfiguratorCommandOrderService} from './api/configuratorCommandOrder.service';
import {ConfiguratorI18nService} from './api/configuratorI18n.service';
import {EngineWorkflowService} from './api/engineWorkflow.service';
import {ConfiguratorContactService} from './api/configuratorContact.service';
import {ConfiguratorProviderService} from './api/configuratorProvider.service';
import {ConfiguratorTaskService} from './api/configuratorTask.service';
import {ConfiguratorSaveQueryService} from './api/configuratorSaveQuery.service';
import {ConfiguratorUserUiPreferenceService} from './api/configuratorUserUiPreference.service';
import {EngineDataQueryService} from './api/engineDataQuery.service';
import {EnginePublicDownloadService} from './api/enginePublicDownload.service';
import {EngineSearchInvoiceService} from './api/engineSearchInvoice.service';
import {ConfiguratorCallInvoicesService} from './api/configuratorCallInvoices.service';
import {ConfiguratorValidatorService} from './api/configuratorValidator.service';
import {ConfiguratorI18nCacheService} from './api/configuratorI18nCache.service';
import {CacheJsService} from './api/cache-js.service';
import {ConfiguratorPingService} from './api/configuratorPing.service';
import {EngineStatisticsService} from './api/engineStatistics.service';
import {EngineLandingPageService} from './api/engineLandingPage.service';
import {EnginePingService} from './api/enginePing.service';
import {EnginePublicUpdateService} from './api/enginePublicUpdate.service';
import {EngineSqlService} from './api/engineSql.service';
import {EngineStructureService} from './api/engineStructure.service';
import {ConfiguratorPublicUpdateService} from './api/configuratorPublicUpdate.service';
import {ConfiguratorStatisticsCacheService} from './api/configuratorStatisticsCache.service';
import {ConfiguratorStructureService} from './api/configuratorStructure.service';
import {ConfiguratorTenantConfigurationService} from './api/configuratorTenantConfiguration.service';
import {ConfiguratorTraductionService} from './api/configuratorTraduction.service';
import {EngineCampaignService} from './api/engineCampaign.service';
import {EngineCampaignGroupService} from './api/engineCampaignGroup.service';
import {ConfiguratorPublicI18nCacheService} from './api/configuratorPublicI18nCache.service';
import {GatewayPublicUserService} from './api/gatewayPublicUser.service';
import {GatewayRoleResourceService} from './api/gatewayRoleResource.service';
import {GatewayLogoutResourceService} from './api/gatewayLogoutResource.service';
import {GatewayAccountService} from './api/gatewayAccount.service';
import {EngineTagService} from './api/engineTag.service';
import {EngineTagEventService} from './api/engineTagEvent.service';
import {EngineTagEventPersonalService} from './api/engineTagEventPersonal.service';
import {ConfiguratorScheduleService} from './api/configuratorSchedule.service';
import {ConfiguratorCompanyService} from './api/configuratorCompany.service';
import {EngineSharedFileService} from './api/engineSharedFile.service';
import {EngineScenarioService} from './api/engineScenario.service';
import {GatewayUserActivityService} from "./api/gatewayUserActivity.service";
import {ConfiguratorScenarioService} from "./api/configuratorScenario.service";

@NgModule({
    imports: [
        // GraphQLModule
    ],
    declarations: [],
    exports: [
        // GraphQLModule
    ],
    providers: [
        // Configurator
        ConfiguratorCallInvoicesService,
        ConfiguratorCommandOrderService,
        ConfiguratorConfigurationService,
        ConfiguratorContactService,
        ConfiguratorDataViewService,
        ConfiguratorDatastoreService,
        ConfiguratorEtlService,
        ConfiguratorFileConnectionService,
        ConfiguratorI18nCacheService,
        ConfiguratorI18nService,
        ConfiguratorLandingPageService,
        ConfiguratorNewsletterService,
        ConfiguratorPageHtml5Service,
        ConfiguratorPingService,
        ConfiguratorProviderService,
        ConfiguratorPublicLandingPageService,
        ConfiguratorPublicNewsletterService,
        ConfiguratorPublicUpdateService,
        ConfiguratorSaveQueryService,
        ConfiguratorUserUiPreferenceService,
        ConfiguratorScenarioService,
        ConfiguratorScriptService,
        ConfiguratorSendInBlueService,
        ConfiguratorStatisticsCacheService,
        ConfiguratorStructureService,
        ConfiguratorTableService,
        ConfiguratorTaskService,
        ConfiguratorTemplateHtmlService,
        ConfiguratorTenantConfigurationService,
        ConfiguratorTenantService,
        ConfiguratorTokenService,
        ConfiguratorTraductionService,
        ConfiguratorTransactionalEmailService,
        ConfiguratorValidatorService,
        ConfiguratorWorkflowService,
        ConfiguratorPublicI18nCacheService,
        ConfiguratorScheduleService,
        ConfiguratorCompanyService,
        // Engine
        EngineCampaignService,
        EngineCampaignGroupService,
        EngineDataQueryService,
        EngineEtlService,
        EngineLandingPageService,
        EnginePingService,
        EnginePublicDownloadService,
        EnginePublicLandingPageService,
        EnginePublicPersonalService,
        EnginePublicUpdateService,
        EngineQueryService,
        EngineRgpdService,
        EngineScriptService,
        EngineSearchInvoiceService,
        EngineSqlService,
        EngineStatisticsService,
        EngineStructureService,
        EngineTransactionalEmailService,
        EngineWebHookService,
        EngineWorkflowService,
        EngineTagService,
        EngineTagEventService,
        EngineTagEventPersonalService,
        EngineSharedFileService,
        EngineScenarioService,
        // Gateway
        GatewayPublicUserService,
        GatewayRoleResourceService,
        GatewayLogoutResourceService,
        GatewayAccountService,
        GatewayUserActivityService,
        // Other
        CacheJsService,
        //
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DmpApiHttpInterceptor,
            multi: true,
        },
        //
        // GraphQlService,
    ],
})
export class ApiModule {
    /*
  public static forRoot(
    configurationFactory: () => Configuration
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
          'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
          'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
  */
}
